function renderListFieldJsxFieldControllerTemplate({
  name,
  nfName,
  nfLabelRaw,
  selectClass,
  escapeJsx,
  selectItems,
  errorMessageLine
}: {
  name: string
  nfName: string
  nfLabelRaw: string
  selectClass: string
  escapeJsx: string
  selectItems: string
  errorMessageLine: string
}): string {
  return `                    <Controller
                      control={form.control}
                      name={\`${name}.\${index}.${nfName}\`}
                      render={({ field }) => (
                        <div className="flex-1 space-y-2">
                          <label htmlFor={field.name} className="text-sm font-medium leading-none">${nfLabelRaw}</label>
                          <select
                            id={field.name}
                            value={field.value ?? ''}
                            onChange={field.onChange}
                            onBlur={field.onBlur}
                            name={field.name}
                            ref={field.ref}
                            className="${selectClass}"
                          >
                            <option value="">${escapeJsx}</option>
${selectItems}
                          </select>
${errorMessageLine}
                        </div>
                      )}
                    />`
}

function renderListFieldJsxFieldControllerFieldNameTemplate({
  name,
  nfName,
  nfLabelRaw,
  escapeAttribute,
  inputClass,
  errorMessageLine
}: {
  name: string
  nfName: string
  nfLabelRaw: string
  escapeAttribute: string
  inputClass: string
  errorMessageLine: string
}): string {
  return `                    <Controller
                      control={form.control}
                      name={\`${name}.\${index}.${nfName}\`}
                      render={({ field }) => (
                        <div className="flex-1 space-y-2">
                          <label htmlFor={field.name} className="text-sm font-medium leading-none">${nfLabelRaw}</label>
                          <input
                            id={field.name}
                            type="number"
                            placeholder="${escapeAttribute}"
                            value={field.value ?? ''}
                            onChange={(event) => {
                              const nextValue = event.target.value === '' ? undefined : event.target.valueAsNumber
                              const normalizedValue = Number.isNaN(nextValue) ? undefined : nextValue
                              field.onChange(normalizedValue)
                            }}
                            onBlur={field.onBlur}
                            name={field.name}
                            ref={field.ref}
                            className="${inputClass}"
                          />
${errorMessageLine}
                        </div>
                      )}
                    />`
}

function renderListFieldJsxFieldControllerFieldNameFieldTemplate({
  name,
  nfName,
  nfLabelRaw,
  escapeAttribute,
  inputClass,
  errorMessageLine
}: {
  name: string
  nfName: string
  nfLabelRaw: string
  escapeAttribute: string
  inputClass: string
  errorMessageLine: string
}): string {
  return `                    <Controller
                      control={form.control}
                      name={\`${name}.\${index}.${nfName}\`}
                      render={({ field }) => (
                        <div className="flex-1 space-y-2">
                          <label htmlFor={field.name} className="text-sm font-medium leading-none">${nfLabelRaw}</label>
                          <input
                            id={field.name}
                            type="text"
                            placeholder="${escapeAttribute}"
                            value={field.value ?? ''}
                            onChange={field.onChange}
                            onBlur={field.onBlur}
                            name={field.name}
                            ref={field.ref}
                            className="${inputClass}"
                          />
${errorMessageLine}
                        </div>
                      )}
                    />`
}

function renderListFieldJsxClickHandlerTemplate({
  labelWithDescriptionLine,
  name,
  nestedFieldsJsx,
  defaultObj,
  singularLabel
}: {
  labelWithDescriptionLine: string
  name: string
  nestedFieldsJsx: string
  defaultObj: string
  singularLabel: string
}): string {
  return `        <div className="space-y-2">
          ${labelWithDescriptionLine}
          {${name}FieldArray.fields.map((item, index) => (
            <div key={item.id} className="relative rounded-sm border p-4">
              <button
                type="button"
                onClick={() => ${name}FieldArray.remove(index)}
                className="absolute right-2 top-2 inline-flex h-7 w-7 items-center justify-center rounded-md text-muted-foreground hover:bg-destructive/10 hover:text-destructive"
              >
                <Trash2 className="size-4" />
                <span className="sr-only">Remove</span>
              </button>
              <div className="space-y-4 pr-8">
${nestedFieldsJsx}
              </div>
            </div>
          ))}
          <button
            type="button"
            onClick={() => ${name}FieldArray.append({ ${defaultObj} })}
            className="inline-flex h-9 items-center justify-center rounded-md border border-input bg-background px-4 py-2 text-sm font-medium shadow-xs transition-colors hover:bg-accent hover:text-accent-foreground disabled:pointer-events-none disabled:opacity-50"
          >
            Add ${singularLabel}
          </button>
        </div>`
}

export function renderFormPipelineListFieldJsxRenderer(
  request:
    | {
        kind: 'renderListFieldJsxFieldControllerTemplate'
        props: {
          name: string
          nfName: string
          nfLabelRaw: string
          selectClass: string
          escapeJsx: string
          selectItems: string
          errorMessageLine: string
        }
      }
    | {
        kind: 'renderListFieldJsxFieldControllerFieldNameTemplate'
        props: {
          name: string
          nfName: string
          nfLabelRaw: string
          escapeAttribute: string
          inputClass: string
          errorMessageLine: string
        }
      }
    | {
        kind: 'renderListFieldJsxFieldControllerFieldNameFieldTemplate'
        props: {
          name: string
          nfName: string
          nfLabelRaw: string
          escapeAttribute: string
          inputClass: string
          errorMessageLine: string
        }
      }
    | {
        kind: 'renderListFieldJsxClickHandlerTemplate'
        props: {
          labelWithDescriptionLine: string
          name: string
          nestedFieldsJsx: string
          defaultObj: string
          singularLabel: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderListFieldJsxFieldControllerTemplate':
      return renderListFieldJsxFieldControllerTemplate(request.props)
    case 'renderListFieldJsxFieldControllerFieldNameTemplate':
      return renderListFieldJsxFieldControllerFieldNameTemplate(request.props)
    case 'renderListFieldJsxFieldControllerFieldNameFieldTemplate':
      return renderListFieldJsxFieldControllerFieldNameFieldTemplate(request.props)
    case 'renderListFieldJsxClickHandlerTemplate':
      return renderListFieldJsxClickHandlerTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
